var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiggybankWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.1667V13.3333H4.16667V14.1667H5ZM5 16.6667H4.16667C4.16667 17.1269 4.53976 17.5 5 17.5V16.6667ZM8.33333 16.6667V17.5C8.79357 17.5 9.16667 17.1269 9.16667 16.6667H8.33333ZM8.33333 14.1667H9.16667V13.3333H8.33333V14.1667ZM4.16667 14.1667V16.6667H5.83333V14.1667H4.16667ZM5 17.5H8.33333V15.8333H5V17.5ZM9.16667 16.6667V14.1667H7.5V16.6667H9.16667ZM5 15H8.33333V13.3333H5V15Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.6667V14.1667H15V16.6667H11.6667Z",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.83333H4.58333H4.16667C3.24619 5.83333 2.5 6.57952 2.5 7.5V12.5C2.5 13.4205 3.24619 14.1667 4.16667 14.1667H15.8333C16.7538 14.1667 17.5 13.4205 17.5 12.5V7.49999C17.5 6.57952 16.7538 5.83333 15.8333 5.83333H14.1667",
    stroke: "#5F5F5F",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.83333,
    r: 1.66667,
    stroke: "#5F5F5F",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggybankWt);
export default __webpack_public_path__ + "static/media/PiggybankWT.b04fa575fb15f9e8db6f9cb8f55b39c5.svg";
export { ForwardRef as ReactComponent };